import { Flex, Spacing } from '@billy/design-system'
import { ChangeEvent, ReactElement, useCallback } from 'react'

import {
  useManualPayment,
  useMultiplePayableSubjects,
  usePaymentModal,
} from '../../../../../paymentReconciliationModal/contexts'
import { PartialOrOverPaymentInput, PartialOrOverPaymentSwitch } from './elements'
import * as Styled from './styles'

interface CrossCurrencyPaymentAmountProps {
  convertedCurrencyId?: string
  subjectCurrencyId?: string | null
}

export const CrossCurrencyPaymentAmount = ({
  convertedCurrencyId,
  subjectCurrencyId,
}: CrossCurrencyPaymentAmountProps): ReactElement => {
  const { isPartialOrOverPayment, setIsPartialOrOverPayment } = usePaymentModal()
  const { selectedSubjectsAmountsSum } = useMultiplePayableSubjects()
  const { setCrossCurrencyPaymentAmount } = useManualPayment()
  const handlePartialOrOverPaymentChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const checked = event.target.checked
      const resettedValue = checked ? 0 : selectedSubjectsAmountsSum
      setCrossCurrencyPaymentAmount(resettedValue)
      setIsPartialOrOverPayment(checked)
    },
    [selectedSubjectsAmountsSum, setCrossCurrencyPaymentAmount, setIsPartialOrOverPayment],
  )

  return (
    <Styled.PaymentSection showIcon={false} variant="neutral">
      <Flex justifyContent="space-between" alignItems="center" gap={Spacing.S12}>
        <PartialOrOverPaymentSwitch
          isPartialOrOverPayment={isPartialOrOverPayment}
          handlePartialOrOverPaymentChange={handlePartialOrOverPaymentChange}
        />
        {isPartialOrOverPayment && (
          <PartialOrOverPaymentInput convertedCurrencyId={convertedCurrencyId} subjectCurrencyId={subjectCurrencyId} />
        )}
      </Flex>
    </Styled.PaymentSection>
  )
}
